import styled from 'styled-components';
import { palette } from '@dev/ee-components';

export const ContentWrapper = styled.div`
    & > label {
        margin-top: 16px;
    }
    & > label:first-of-type {
        margin-top: 0;
    }
`;

export const AlertWrapper = styled.div`
    .MuiPaper-root {
        background-color: ${palette.red[1]} !important;
        padding: 6px 16px !important;
        margin-bottom: 16px;
    }
`;
